/**
 * Created by axxil on 28.12.16.
 */
ymaps.ready(function() {
    var mapArea = document.getElementById('map');
    var zoom = mapArea.getAttribute('data-zoom');
    var lat = 55.7887400;
    var lng = 49.1221400;
    var tpl = 'front';
    if (mapArea.hasAttribute("data-lat")) {
        lat = mapArea.getAttribute('data-lat');
        lng = mapArea.getAttribute('data-lng');
    }
    var map = new ymaps.Map("map", {
        center: [lat, lng],
        zoom: zoom
    });

    if (mapArea.hasAttribute("data-lat")) {
        map.geoObjects.add(new ymaps.Placemark([lat, lng], {},{
            preset: 'islands#blueHouseIcon'
        }));
    }

    if (mapArea.hasAttribute("data-tpl")) {
        tpl = mapArea.getAttribute('data-tpl');
    }

    var hash = mapArea.getAttribute('data-hash');
    var page = mapArea.getAttribute('data-page');
    var entity = mapArea.getAttribute('data-entity');

    $.getJSON('/api/map/' + entity,{hash:hash,page:page},function(data){
        map.geoObjects.add(collectionFactory(entity, data));
    });

    var collectionFactory = function (entity, data) {
        if (entity == 'infrastructures' ) {
            return infrastructuresCollection(entity, data);
        } else {
            return defaultCollection(entity, data, tpl);
        }
    }

    var infrastructuresCollection = function(entity, data) {
        var collection = new ymaps.GeoObjectCollection(null, {
            preset: 'islands#circleIcon'
        });
        var infra = [];
        $.each(data,function (key,item) {
            var tag = infrastructureTagName(item.tag_id);
            collection.add(point(item.lat,item.lng,balloonFactory(entity,item),{
                preset: 'islands#circleIcon',
                iconColor: tag.color
            }));
            if (array_key_exists(item.tag_id,infra)) {
                infra[item.tag_id] += 1;
            } else {
                infra[item.tag_id] = 1;
            }
        })
        var html = '';
        infra.forEach(function(count,tag_id){
            var tag = infrastructureTagName(tag_id);
            html += '<li class="mdc-bg-red-300" style="background-color: ' + tag.color + '!important">'+ tag.title + ':' + count +'</li>';
        })
        $('#infrastructure-legend').html(html);
        return collection;
    }

    var defaultCollection = function(entity, data, tpl) {
        var collection = new ymaps.GeoObjectCollection(null, {
            preset: 'islands#circleIcon'
        });
        $.each(data,function (key,item) {
            collection.add(point(item.lat,item.lng,balloonFactory(entity,item,tpl)));
        })
        return collection;
    }

    var point = function(lat,lng,balloonContent,preset) {
        if (preset) {
            return new ymaps.Placemark([lat, lng], {
                balloonContent: balloonContent
            },preset);
        } else {
            return new ymaps.Placemark([lat, lng], {
                balloonContent: balloonContent
            });
        }
    }

    var balloonFactory = function (entity,data,tpl) {
        if (entity == 'ads') {
            return adsBalloon(data);
        }
        if (entity == 'houses') {
            return housesBalloon(data, tpl);
        }
        if (entity == 'complexes') {
            return complexesBalloon(data);
        }
        if (entity == 'infrastructures') {
            return infrastructuresBalloon(data);
        }
    }

    var adsBalloon =  function(data) {
        var balloonContent = '<strong style="color:blue;font-size:1.1em;">' + data.price + '</strong><br>';
        balloonContent += data.address + '<br>';
        balloonContent += data.title;
        return balloonContent;
    };

    var housesBalloon =  function(data, tpl) {
        var balloonContent = '';
        if (tpl == 'manager') {
            balloonContent = '<strong style="color:blue;font-size:1.1em;">' + data.address + '</strong><br>';
            balloonContent += '<a href="/manager/house/'+data.id+'/edit">редактировать</a>';
        } else {
            balloonContent = '<strong style="color:blue;font-size:1.1em;">от ' + data.price + '</strong><br>';
            balloonContent += data.address + '<br>';
            balloonContent += data.floors + ' этажей<br>';
        }
        return balloonContent;
    };

    var complexesBalloon =  function(data) {
        var balloonContent = '<strong style="color:blue;font-size:1.1em;">от ' + data.price + '</strong><br>';
        balloonContent += data.title + '<br>';
        balloonContent += data.floors + ' этажей<br>';
        return balloonContent;
    };

    var infrastructuresBalloon =  function(data) {
        var balloonContent = '<strong style="color:blue;font-size:1.1em;">' + data.title + '</strong><br>';
        balloonContent += data.address + '<br>';
        return balloonContent;
    };

    var array_key_exists = function ( key, search ) {
        // input sanitation
        if( !search || (search.constructor !== Array && search.constructor !== Object) ){
            return false;
        }

        return search[key] !== undefined;
    }

    var infrastructureTagName = function(tag_id) {
        var data = [{},
            {title:'Тренажёрные залы',color: 'blue'},
            {title:'Бассейны',color: 'darkblue'},
            {title:'Детские спортшколы',color: 'orange'},
            {title:'Детские сады',color: 'darkorange'},
            {title:'Школы',color: 'violet'},
            {title:'Взрослые поликлиники',color: 'pink'},
            {title:'Детские поликлиники',color: 'red'},
            {title:'Школы раннего развития',color: 'lightblue'},
            {title:'Детское доп. образование',color: 'night'},
            {title:'Кинотеатры',color: 'brown'},
            {title:'Банкоматы',color: 'gray'},
            {title:'Парковки',color: 'green'},
            {title:'Продуктовые магазины',color: 'black'},
            {title:'Торговые центры',color: 'black'},
            {title:'Аптеки',color: 'brown'}];
        return data[tag_id];
    }
})
